// 收款信息列表
<template>
  <div>
    <collection-list :cate="cate" ref="collectionList"></collection-list>
  </div>
</template>

<script>
import CollectionList from "@/views/payment2.0/CollectionList.vue";

export default {
  name: "Collection",
  components: {
    CollectionList,
  },
  data() {
    return {
      cate: "Collection",
    };
  },
  mounted() {
    this.$refs.collectionList.init();
  },
};
</script>